import { BookingService } from '@ibe/services';
import { bookingService } from './Contexts';

function useBookingService(): BookingService {
  return bookingService;
}

export default useBookingService;
